<template>
    <div>
        <!-- Transfer işlemi -->
        <div v-if="isTransfer && (sourceStorages.length > 0 || destStorages.length > 0)" class="d-flex align-items-center flex-nowrap">
            <!-- Kaynak Depolar -->
            <div class="d-flex flex-nowrap align-items-center">
                <b-badge v-for="(source, idx) in sourceStorages" :key="'src-' + idx" variant="light-danger" class="mr-25 mb-25">
                    {{ source }}
                </b-badge>
            </div>

            <feather-icon icon="ArrowRightIcon" class="text-primary mx-50" size="16" />

            <!-- Hedef Depolar -->
            <div class="d-flex flex-nowrap align-items-center">
                <b-badge v-for="(dest, idx) in destStorages" :key="'dest-' + idx" variant="light-success" class="mr-25 mb-25">
                    {{ dest }}
                </b-badge>
            </div>
        </div>

        <!-- Yakıt Girişi -->
        <b-badge v-else-if="isInput" variant="light-success">{{ row.StorageNames || "-" }}</b-badge>

        <!-- Yakıt Çıkışı -->
        <b-badge v-else-if="isOutput" variant="light-danger">{{ row.StorageNames || "-" }}</b-badge>

        <!-- Stok Dengeleme -->
        <b-badge v-else-if="isBalance" variant="light-info">{{ row.StorageNames || "-" }}</b-badge>

        <!-- Fallback -->
        <span v-else>{{ row.StorageNames || "-" }}</span>
    </div>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    name: "TransferRouteCell",
    components: { BBadge },
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isTransfer() {
            return this.row.FuelTransactionType === 3;
        },
        isInput() {
            return this.row.FuelTransactionType === 1 || this.row.FuelTransactionType === 6;
        },
        isOutput() {
            return this.row.FuelTransactionType === 0;
        },
        sourceStorages() {
            if (!this.isTransfer || !this.row.FuelStorageTransferTransactionDetails) return [];
            return this.row.FuelStorageTransferTransactionDetails.filter((d) => d.TransactionType === 0).map((d) => `${d.FuelStorageName} (${d.FuelStorageCode})`);
        },
        destStorages() {
            if (!this.isTransfer || !this.row.FuelStorageTransferTransactionDetails) return [];
            return this.row.FuelStorageTransferTransactionDetails.filter((d) => d.TransactionType === 1 || d.TransactionType === 6).map((d) => `${d.FuelStorageName} (${d.FuelStorageCode})`);
        },
        isBalance() {
            return this.row.FuelTransactionType === 5;
        },
    },
};
</script>
